import { ControlFacet, childControlOption } from '../models/controls/ControlFacet';
import { IBreadcrumbProps } from 'office-ui-fabric-react/lib/Breadcrumb';
import { defaultRenderComponentOption } from '../components/controls/defaultRenderComponentControlOption';

export const crumbControl: ControlFacet<{
  itemKey: string;
}, {
    parentItemKey: string | undefined;
    displayName: string;
    action: JSX.Element | null;
  }> = new ControlFacet('crumbControl');

export const itemsBreadcrumbBetaControl: ControlFacet<{
  itemKey: string;
  itemsScopeItemKey: string;
}, {
    leafItemKey: string;
    crumbControlHandler: typeof crumbControl.type;
    breadcrumbAs: React.ComponentType<IBreadcrumbProps>;
  }> = new ControlFacet<{
    itemKey: string;
    itemsScopeItemKey: string;
  }, {
      leafItemKey: string;
      crumbControlHandler: typeof crumbControl.type;
      breadcrumbAs: React.ComponentType<IBreadcrumbProps>;
    }>('itemsBreadcrumbBetaControl', {
      crumbControlHandler: childControlOption(crumbControl),
      breadcrumbAs: defaultRenderComponentOption<IBreadcrumbProps>()
    });
